// ----------------------------------------------------------------------
// <copyright file="Izenda.ReportHistory.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------
!(function() {
  var m = require('mobx');
  var PagingModel = require('share/components/controls/DataGrid/helpers/Izenda.PagingModel');

  function ReportHistory() {
    var colSortDir = {
      version: 'DESC'
    };

    var defaultSearchProperty = 'All';

    var props = {
      histories: [],
      pageInfo: new PagingModel(colSortDir, defaultSearchProperty)
    };

    m.extendObservable(this, props);
  }

  /**
   * Read histories list
   * @param {Object} data
   */
  ReportHistory.prototype.readHistory = m.action(function(data) {
    data = data || {};
    var result = data.result || [];

    this.histories = result;

    // update page info
    this.pageInfo.totalRecords = data.total;

    return null;
  });

  module.exports = ReportHistory;
})();



// WEBPACK FOOTER //
// ./ui/logic/models/Izenda.ReportHistory.js